/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import onClickOutside from 'react-onclickoutside'

/**
 *     Import
 *     - CSS
 */
import './styles/Notifications.css'

/**
 *     Import
 *     - Components
 */
import NotificationsContent from './components/NotificationsContent'

/**
 *     Import
 *     - Images
 */
import { NotificationIcon } from '../../../images/icons/Notification/Notification'

/**
 * Class for the Notification box and indicator
 *
 * @class Notifications
 * @extends {React.Component<any, any>}
 */
class Notifications extends React.Component<any, any> {

    /**
     * Creates an instance of Notifications.
     * @param {*} props
     * @memberof Notifications
     */
    constructor(props: any) {
        super(props)
        this.state = {
            checked: false,
            newNotifications: false,
            counter: 0,
            notifications: [],
        }
    }

    componentWillMount() {
        this.props.getNotifications()
    }

    componentWillReceiveProps(nextProps: any) {
        if (this.props !== nextProps) {
            if (nextProps.notifications.notificationList.done) {
                this.setState(
                    {
                        newNotifications: nextProps.notifications.notificationList.response.newNotifications,
                        notifications: nextProps.notifications.notificationList.response.notifications,
                        counter: nextProps.notifications.notificationList.response.counter,
                    }
                )
            }
            if (nextProps.notifications.readNotifications.done &&
                nextProps.notifications.readNotifications.response.success
            ) {
                this.setState({ newNotifications: false })
            }
        }
    }

    /**
     * Handle an outside click for closing notifications
     *
     * @param {any} evt The event to trigger
     * @memberof Notifications
     */
    handleClickOutside = (evt: any) => {
        this.setState({ checked: false })
    }

    /**
     * Change the state of theNotification box
     *
     * @param {any} newState the new state to update
     * @memberof Notifications
     */
    changeButtonState = (newState: any) => {
        if (newState.newNotifications) {
            this.props.readNotifications()
        }
        this.setState(newState)
    }

    render() {
        return (
            <div className={`notifications`}>
                <div
                    className={`notifications__nav ${(this.state.checked) ? 'active' : ''}
                    ${this.state.newNotifications ? 'newNotifications' : ''}`}
                    onClick={
                        () => {
                            this.changeButtonState(
                                {
                                    checked: !this.state.checked,
                                    newNotifications: this.state.newNotifications,
                                }
                            )
                        }
                    }
                >
                    <div className="notifications__nav__button">
                        <NotificationIcon
                            state={this.state}
                        />
                    </div>
                </div>
                <div className={`notifications__box ${(this.state.checked) ? 'active' : ''}`}>
                    <NotificationsContent
                        notificationList={this.state.notifications}
                    />
                </div>
                {this.state.newNotifications &&
                    <div className={`counter ${this.state.newNotifications ? 'active' : ''}`}>
                        {this.state.counter}
                    </div>}
            </div>
        )
    }
}

export default onClickOutside(Notifications)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Notifications/Notifications.tsx